import { useSnackbarContext } from 'Context/SnackbarContext';
import { useState } from 'react';
import useSelectScenarioContext
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/SelectScenarioContext';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const useRoadmapExecutiveSummaryScenarioSelection = ({ resource }) => {
  const [confirmationDialogResource, setConfirmationDialogResource] = useState(null);
  const { displayErrorMessage } = useSnackbarContext();
  const { setIsSelecting, onSelectSuccess } = useSelectScenarioContext();
  const { loadPageContentLink } = usePageContentContext();

  const selectScenario = async (rel) => {
    setIsSelecting(true);
    try {
      const [resourceToSubmit] = await rel.link('related').get();
      await resourceToSubmit.submit();

      // If the next up refresh relationship, is present we should go there. Otherwise, we should execute onSelectSuccess, as select was actually executed.
      await resource.withRelationship(fr.relationships.nextUpRefreshStep.name,
        (refreshStepRel) => loadPageContentLink(refreshStepRel.link('related')),
        async () => {
          await onSelectSuccess(resource);
        });
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Error: Select failed, please try again');
    } finally {
      setIsSelecting(false);
    }
  };

  const openConfirmationDialog = async (rel) => {
    const [confirmationResource] = await rel.link('related').get();
    setConfirmationDialogResource(confirmationResource);
  };

  const onSelectScenarioClick = async (rel) => {
    try {
      if (rel.meta('modal')) {
        await openConfirmationDialog(rel);
        return;
      }

      await selectScenario(rel);
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Error: Select failed, please try again');
    } finally {
      setIsSelecting(false);
    }
  };

  return {
    confirmationDialogResource,
    setConfirmationDialogResource,
    onSelectScenarioClick,
    selectScenario,
  };
};

export { useRoadmapExecutiveSummaryScenarioSelection };
